import { t } from "../services/utils";
const channelTypes = {
  CHAT: 1,
  NOTES: 2,
  ASSESSMENT_NOTES: 3
};
export default channelTypes;